import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next
      .handle(request)
      .pipe
      // tap((res: HttpResponse<AppResponse>) => {
      //   this.service.showError(res.body);
      // }),
      // catchError((res: HttpErrorResponse) => {
      //   this.service.showError(res.error);
      //   return throwError(res);
      // })
      ();
  }
}
